// The learner origin serves each catalog company's logo as a static file named by its id.
export const companyLogoAddress = (companyId: string): string => `/companylogos/${encodeURIComponent(companyId)}.svg`;
